module.exports = __webpack_public_path__ + "img/energy2.9723990e.png";